import { render, staticRenderFns } from "./choose-team.vue?vue&type=template&id=29708264&scoped=true"
import script from "./choose-team.vue?vue&type=script&lang=js"
export * from "./choose-team.vue?vue&type=script&lang=js"
import style0 from "./choose-team.vue?vue&type=style&index=0&id=29708264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29708264",
  null
  
)

export default component.exports